export default {
  "1": "广告",
  "2": "線上人數",
  "3": "最新投稿",
  "4": "更多",
  "5": "推廣",
  "6": "綜合得分",
  "7": "當前共有",
  "8": "個線上直播",
  "9": "直播排行",
  "10": "關注的主播",
  "11": "為你推薦",
  "12": "特別推薦",
  "13": "番劇動態",
  "14": "國產原創相關",
  "15": "新番時間表",
  "16": "最新",
  "17": "週一",
  "18": "週二",
  "19": "週三",
  "20": "週四",
  "21": "週五",
  "22": "週六",
  "23": "週日",
  "24": "返回<br />舊版",
  "25": "換一換",
  "26": "排行榜",
  "27": "播放",
  "28": "遊戲賽事",
  "29": "觀看列表",
  // 漫画
  "30": "人氣推薦",
  "31": "免費漫畫推薦",
  "32": "下載",
  "33": "領券免費看",
  "34": "月票",
  "35": "應援",
  "36": "飆升",
  // 左侧
  "37": "試用反饋",
  "38": "聯絡客服",
}